var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 14.25H14.25V7.48346L9 3.40046L3.75 7.48346V14.25H8.25V9.74996H9.75V14.25ZM15.75 15C15.75 15.1989 15.671 15.3896 15.5303 15.5303C15.3897 15.6709 15.1989 15.75 15 15.75H3C2.80109 15.75 2.61032 15.6709 2.46967 15.5303C2.32902 15.3896 2.25 15.1989 2.25 15V7.11746C2.24992 7.00317 2.27596 6.89037 2.32614 6.78768C2.37631 6.685 2.44929 6.59513 2.5395 6.52496L8.5395 1.85846C8.67116 1.75604 8.8332 1.70044 9 1.70044C9.1668 1.70044 9.32884 1.75604 9.4605 1.85846L15.4605 6.52496C15.5507 6.59513 15.6237 6.685 15.6739 6.78768C15.724 6.89037 15.7501 7.00317 15.75 7.11746V15V15Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b895b6ea.svg";
export { ForwardRef as ReactComponent };